import { useStore } from "@nanostores/react"
import { atom } from "nanostores"
import { User, Asset } from "../service/service"
import { Param } from "../type/param"

export const paramAtom = atom<Param>()
export const userAtom = atom<User>()
export const assetAtom = atom<Asset>()
export const decimalAtom = atom<{
  data?: number
  error?: Error
  loading?: boolean
}>()
export const amountAtom = atom<string | undefined>()
export const memoAtom = atom<string | undefined>()

export const useAmount = () => {
  const { amount: initAmount } = useStore(paramAtom)
  const amount = useStore(amountAtom)
  return initAmount || amount
}

export const useMemoString = () => {
  const { memo: initMemo } = useStore(paramAtom)
  const memo = useStore(memoAtom)
  return initMemo || memo
}
